import { Button, Box, useTheme, FormLabel, Select } from "@chakra-ui/react";
import { ComponentProps } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";

import { useQuizActions } from "./state";
import { useSlide } from "../public/slide";
import { commonInputStyles } from "./commonInput";

export function NextButton(props: ComponentProps<typeof Button>) {
  const quiz = useQuizActions();
  const theme = useTheme();
  const { nextButtonProps } = useSlide();
  const { t } = useTranslation();

  const title = nextButtonProps?.title ?? t("quizLib.ui.next", { defaultValue: "Next" });

  return (
    <Box mx={4} mb={4}>
      <Button
        px={6}
        py={4}
        variant={"solid"}
        backgroundColor="primary.600"
        _hover={{
          backgroundColor: "primary.500",
        }}
        width={"full"}
        boxShadow={`0 0 0 6px ${theme.colors.brand["800"]}`}
        onClick={() => {
          const ok = quiz.submitQuestion();
          if (ok) {
            quiz.goToNext();
          }
        }}
        {...props}
      >
        {title}
      </Button>
    </Box>
  );
}

export function MyFormLabel({ color = "#9d7683", ...props }: ComponentProps<typeof FormLabel>) {
  return (
    <FormLabel fontWeight={"normal"} color={color} fontSize={"sm"} {...props} lineHeight={1} />
  );
}

export function MySelect(props: ComponentProps<typeof Select>) {
  return <Select {...commonInputStyles()} {...props}></Select>;
}
